import React, { Component, StrictMode, useEffect } from "react";
import ReactDOM from 'react-dom/client';
import { useSelector, useDispatch } from "react-redux";

const Launcher = () => {
  
  const dispatch = useDispatch();

  const isDivWidget = useSelector(state => state.launcher.isDivWidget);

  if (isDivWidget) {
    return <></>;
  }

  return (
    <div className="kil-chat-launcher"
    onClick={(e) => {
      e.preventDefault();
      dispatch({ type: 'LAUNCHER_CLICKED' })
    }}>
      <i className="kil-chat-launcher-icon fa fa-comments"></i>
    </div>
  );
}

export default Launcher;